// extracted by mini-css-extract-plugin
module.exports = {"container":"df5dab2e92--container--oH4gj","card":"df5dab2e92--card--vDRHr","image":"df5dab2e92--image--YMPEY"};